import { render, staticRenderFns } from "./HearingJourney.vue?vue&type=template&id=6302c89e&"
import script from "./HearingJourney.vue?vue&type=script&lang=js&"
export * from "./HearingJourney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiButtonIcon: require('/codebuild/output/src2284964156/src/med-el-hearpeers/components/Ui/Button/Icon.vue').default})
